import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';
import { Card, Button, CardBody, CardHeader, CardFooter } from 'reactstrap';

import Squares from './Squares';
import QuestionHeader from '../QuestionHeader';

function PuzzleWords({ data, userData, questionIndex = 0, onSubmit }) {
  // const reducer = React.useCallback((a, c) => ((a - c >= c.answer.length) ? a : c.answer.length), []);

  const answers = React.useMemo(() => data?.answers, [data?.answers]);
  // console.log("🚀 ~ file: index.js ~ line 13 ~ PuzzleWords ~ answers", answers)
  // const size = React.useMemo(() => answers.reduce(reducer, 0) + 1, [answers, reducer]);

  const [state, setState] = React.useState({
    selectedCells: [],
    isSubmitted: false,
    cells: [],
  });

  const onCellClick = React.useCallback((row, cell, cellItem) => {
    setState((prevState) => {
      const selectedCells = JSON.parse(JSON.stringify(prevState.selectedCells));

      const index = selectedCells.findIndex((x) => x.position.row === row && x.position.cell === cell);

      if (index > -1) {
        selectedCells.splice(index, 1);
      } else {
        selectedCells.push({
          position: { row, cell },
          correct: !!cellItem.correct,
        });
      }

      return {
        ...prevState,
        selectedCells,
      };
    });
  }, []);

  const renderAnswer = React.useCallback((answer, index) => {
    return (
      <div key={index}>
        <img src={answer.imageUrl} style={{ width: 150 }} alt='' />
      </div>
    );
  }, []);

  const onHandleSubmit = React.useCallback(() => {
    let checkAnser = true;
    const totalAnser = data?.answers.reduce((previous, current) => (previous += current.answer.length), 0);
    if (totalAnser !== state.selectedCells.length) checkAnser = false;
    if (checkAnser) {
      const isNotCorrect = state.selectedCells.some((x) => x.correct === false);
      checkAnser = !isNotCorrect;
    }
    // console.log("🚀 ~ file: index.js ~ line 58 ~ onHandleSubmit ~ checkAnser", checkAnser)

    setState((prevState) => {
      const updateStates = {
        isSubmitted: !prevState.isSubmitted,
      };

      if (onSubmit && typeof onSubmit === 'function') {
        onSubmit({ answers: { selectedCells: state.selectedCells, cells: state.cells }, result: checkAnser });
      }

      return {
        ...prevState,
        ...updateStates,
      };
    });
  }, [data?.answers, onSubmit, state.cells, state.selectedCells]);

  React.useEffect(() => {
    if (userData) {
      const { selectedCells } = userData.answers;
      setState(pre => ({ ...pre, selectedCells }));
    }
  }, [userData]);

  const receive = React.useCallback((cells) => {
    const max = data?.settings?.question?.columns ?? 8;
    if (state.cells.length === max) return;
    state.cells.push(cells);
    setState(pre => ({ ...pre, cells: state.cells }));
  }, [data?.settings?.question?.columns, state.cells]);

  const renderSquare = React.useMemo(() => {
    return <Squares userData={userData?.answers?.cells} receive={receive} size={data?.settings?.question?.columns ?? 8} answers={answers} isSubmitted={state.isSubmitted} selectedCells={state.selectedCells} onCellClick={onCellClick} />
  }, [answers, data?.settings?.question?.columns, onCellClick, receive, state.isSubmitted, state.selectedCells, userData]);

  const renderAnswerContent = React.useMemo(() => {
    return answers.map(renderAnswer);
  }, [answers, renderAnswer]);

  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='PuzzleWords' />
      </CardHeader>
      <CardBody>
        <div className='d-flex flex-column align-items-center'>
          <div className='flex-1'>
            {renderSquare}
            {/* <Squares size={data?.settings?.question?.columns ?? 8} answers={answers} isSubmitted={state.isSubmitted} selectedCells={state.selectedCells} onCellClick={onCellClick} /> */}
          </div>

          <div className='px-4'>
            <Space direction='horizontal' size='large'>
              {renderAnswerContent}
            </Space>
          </div>
        </div>
      </CardBody>
      <CardFooter>
        <Button color='primary' disabled={state.isSubmitted} onClick={onHandleSubmit}>
          Submit
          <i className='fas fa-arrow-right ml-3' />
        </Button>
      </CardFooter>
    </Card>
  );
}

PuzzleWords.defaultProps = {
  userData: null,
};

PuzzleWords.propTypes = {
  // PropTypes
  data: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  userData: PropTypes.instanceOf(Object),
  questionIndex: PropTypes.number.isRequired,
};

export default PuzzleWords;
